// This icon file is generated automatically.
var PLineHeightOutlined = { "icon": { "tag": "svg", "attrs": { "viewBox": "0 0 14 14", "focusable": "false" }, "children": [{ "tag": "path", "attrs": { "d": "M9.13 1.5H.63a.13.13 0 00-.13.13v2c0 .06.06.12.13.12h.87c.07 0 .13-.06.13-.13v-1h2.62v8.75H2.81a.13.13 0 00-.12.13v.88c0 .06.05.12.12.12h4.13c.07 0 .12-.06.12-.13v-.87a.13.13 0 00-.12-.13H5.5V2.63h2.63v1c0 .06.05.12.12.12h.88c.06 0 .12-.06.12-.13v-2a.13.13 0 00-.13-.12zm4.26 8.53h-1.02V3.97h1.02c.1 0 .14-.11.09-.18l-1.58-2a.11.11 0 00-.18 0l-1.57 2c-.06.07 0 .18.09.18h1.01v6.06h-1.01c-.1 0-.15.11-.1.18l1.58 2c.05.05.14.05.18 0l1.57-2a.11.11 0 00-.08-.18z", "fill-rule": "nonzero" } }] }, "name": "p-line-height", "theme": "outlined" };
export default PLineHeightOutlined;



//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons-svg/es/asn/PLineHeightOutlined.js
// module id = 3486
// module chunks = 0